import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import homeIcon from "../../assets/images/icons/userTherapistPage/home.svg";
import { FiFileText } from "react-icons/fi";
import therapyPlannerIcon from "../../assets/images/icons/userTherapistPage/therapyPlanner.svg";
import messagesIcon from "../../assets/images/icons/userTherapistPage/messages.svg";
import bankIcon from "../../assets/images/icons/userTherapistPage/bank.svg";
import supportIcon from "../../assets/images/icons/userTherapistPage/support.svg";
import settingIcon from "../../assets/images/icons/userTherapistPage/settings.svg";
import profileIcon from "../../assets/images/icons/userTherapistPage/profile.svg";
import signOutIcon from "../../assets/images/icons/userTherapistPage/signOut.svg";
import { useDispatch, useSelector } from "react-redux"
import { logoutTherapist } from "../../redux/therapistSlice";
import { logoutUser } from "../../redux/authSlice";
import { selectTotalUnread } from "../../redux/chatSlice";
import { destroySocket } from "../../services/chatSocket";


function TherapistSideBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const unreadTotal = useSelector(selectTotalUnread);

  const handleLogout = () => {
      destroySocket();
      const storedType = (localStorage.getItem("userType") || "").toLowerCase();
      if (storedType === "therapist") {
        dispatch(logoutTherapist());
        window.location.replace("/signInTherapist");
      } else {
        dispatch(logoutUser());
        window.location.replace("/signIn");
      }
    };

  // Yardımcı fonksiyon: aktif sayfa mı?
  const isActive = (path) => location.pathname === path;

  return (
    <div>
      {/* Sidebar */}
      <aside className="bg-background w-[145px] sm:w-[168px] md:w-[306px] mt-4 md:mt-10 mb-4 md:mb-10 rounded-[11px] md:rounded-[20px] pt-3 pl-3 md:pl-6 ml-2 md:ml-6 shadow-lg notranslate" translate="no">
        <nav>
          <ul className="text-text">
            <div className="space-y-2 md:space-y-6 font-poppins text-[15px] md:text-[28px]">
              <li
                className={`flex items-center gap-2 cursor-pointer hover:text-text ${
                  isActive("/TherapistHomePage") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/TherapistHomePage")}
              >
                <img
                  src={homeIcon}
                  alt="Home"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                {t("home")}
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer hover:text-text ${
                  isActive("/therapistTherapyPlanner") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/therapistTherapyPlanner")}
              >
                <img
                  src={therapyPlannerIcon}
                  alt="Appointment"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                {t("appointment")}
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer hover:text-text ${
                  isActive("/therapistMessages") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/therapistMessages")}
              >
                <div className="relative shrink-0">
                  <img
                    src={messagesIcon}
                    alt="Messages"
                    className="md:w-6 md:h-6 w-4 h-4"
                  />
                  {unreadTotal > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[9px] md:text-[10px] font-bold rounded-full min-w-[14px] md:min-w-[16px] h-[14px] md:h-[16px] flex items-center justify-center px-[3px] leading-none">
                      {unreadTotal > 99 ? "99+" : unreadTotal}
                    </span>
                  )}
                </div>
                {t("messages")}
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer hover:text-text ${
                  isActive("/therapistSettings") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/therapistSettings")}
              >
                <img
                  src={settingIcon}
                  alt="Settings"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                {t("Settings")}
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer hover:text-text ${
                  isActive("/therapistProfileSettings") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/therapistProfileSettings")}
              >
                <img
                  src={profileIcon}
                  alt="Profile Settings"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                {t("Profile")}
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer hover:text-text ${
                  isActive("/therapistPayment") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/therapistPayment")}
              >
                <img
                  src={bankIcon}
                  alt="therapistPayment"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                {t("therapistPayment")}
              </li>
              <li
                className={`flex items-center gap-2 cursor-pointer hover:text-text ${
                  isActive("/therapistClientReports") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/therapistClientReports")}
              >
                <FiFileText className="md:w-6 md:h-6 w-4 h-4 shrink-0" />
                <span className="text-[15px] md:text-[28px] font-poppins">
                  {t("clientReports") || "Client Reports"}
                </span>
              </li>
                <li
                className={`flex items-center gap-2 cursor-pointer hover:text-text ${
                  isActive("/therapistSupport") ? "text-[#E5D3DD]" : ""
                }`}
                onClick={() => navigate("/therapistSupport")}
              >
                <img
                  src={supportIcon}
                  alt="Support"
                  className="md:w-6 md:h-6 w-4 h-4"
                />
                {t("support")}
              </li>
              <button
              className="flex items-center gap-2  hover:text-text cursor-pointer"
              onClick={handleLogout}
            >
              <img
                src={signOutIcon}
                alt="Sign Out"
                className="md:w-6 md:h-6 w-4 h-4"
              />
              {t("signOut")}
            </button>
            </div>
            
          </ul>
        </nav>
      </aside>
    </div>
  );
}

export default TherapistSideBar;
